import * as React from "react";
import { IDropTarget, IDrop, Dnd } from "./Dnd";
import { InvestigatorPortraitComponent } from "./InvestigatorPortrait";
import { ICard, ApplicationException } from "./Card";
import { IScenarioState, ILocation } from "./Scenario";
import { InvestigatorUtil } from "./InvestigatorUtil";

export interface ILocationMenuItemProps {
    state: IScenarioState;
    location: ILocation;
    onChanged: () => void;
}
export class LocationMenuItemComponent extends React.Component<ILocationMenuItemProps, any> implements IDropTarget {
    static newLocationId: number = -1;
    private li: HTMLLIElement;
    constructor(props: ILocationMenuItemProps) {
        super(props);
    }
    allowDrop(dragType: string, effectAllowed: string): string {
        if (this.props.location.card.packNumber === LocationMenuItemComponent.newLocationId) {
            return null;
        }
        if (/^card\/.+/.test(dragType)) {
            return Dnd.move;
        }
        if (dragType === InvestigatorPortraitComponent.dragType) {
            return Dnd.move;
        }
        return null;
    }

    onDrop(drop: IDrop): boolean {
        if (drop.dragType === InvestigatorPortraitComponent.dragType) {
            const investigatorIndex = drop.value as number;

            const inv = this.props.state.investigators[investigatorIndex];
            inv.locationId = this.props.location.card.packNumber;
            const investigatorLocationIndex = InvestigatorUtil.getInvestigatorLocationIndex(this.props.state, this.props.location.card.packNumber, investigatorIndex);
            InvestigatorUtil.moveInvestigatorToLast(this.props.state, this.props.location.card.packNumber, investigatorLocationIndex);
            this.props.onChanged();
            return true;
        }
        if (/^card\/.+/.test(drop.dragType)) {
            const card = drop.value as ICard;
            if (!card) throw new ApplicationException("Value is not a card");
            if (!this.props.location.enemies) {
                this.props.location.enemies = { cards: [] };
            }
            this.props.location.enemies.cards.push(card);
            this.props.onChanged();
            return true;
        }

        return false;
    }
    getDropElement(): HTMLElement {
        return this.li;
    }
    selectLocation(id: number) {
        if (id !== this.props.state.currentSelectedLocationId) {
            this.props.state.currentSelectedLocationId = id;
            //this.setState({ currentSelectedLocationId: id });
            this.props.onChanged();
        }
    }
    public static getCurrentSelectedLocationId(state: IScenarioState): number {
        const locId = state.currentSelectedLocationId;

        //check if new location is selected and we have some inactive locations
        const inactiveLocations = state.locations.filter(l => l.inactive);
        if (locId === LocationMenuItemComponent.newLocationId && inactiveLocations.length)
            return locId;

        //check if current selected location exists and is active, use that
        const selectedLocationArray = state.locations.filter(l => l.card.packNumber === locId && !l.inactive);
        if (selectedLocationArray.length === 1) {
            return selectedLocationArray[0].card.packNumber;
        }

        //else get the first active location id
        const activeLocations = state.locations.filter(l => !l.inactive);
        if (activeLocations.length > 0) {
            return activeLocations[0].card.packNumber;
        }
        //fallback to new Location id
        return LocationMenuItemComponent.newLocationId;
    }
    render() {

        const activeLocId = LocationMenuItemComponent.getCurrentSelectedLocationId(this.props.state);
        let cssClass = "";
        const card = this.props.location.card;
        if (activeLocId === card.packNumber) {
            cssClass = "active";
        }

        let status = "";
        if (card.packNumber !== LocationMenuItemComponent.newLocationId) {
            status += "(";
            const investigators = this.props.state.investigators.filter(i => i.locationId === card.packNumber);
            if (investigators.length) {
                status += investigators.length;
            } else {
                status += "-";
            }
            status += "/";
            if (this.props.location.enemies &&
                this.props.location.enemies.cards &&
                this.props.location.enemies.cards.length) {
                status += this.props.location.enemies.cards.length;
            } else {
                status += "-";
            }
            status += ")";
        }
        let locSymbol: JSX.Element = null;
        if (card.values) {
            const locationSymbol = (card.faceUp ? card.values["symbolFront"] : card.values["symbolBack"]);
            if (locationSymbol) {
                const locationSymbolCss = "location-symbol location-symbol-" + locationSymbol;
                locSymbol = (<i className={locationSymbolCss}></i>);
            }
        }
        return (<li className={cssClass} ref={(ref) => this.li = ref}
            onDragOver={(e) => { Dnd.dragOver(e, this); }}
            onDrop={(e) => { Dnd.drop(e, this); }}
            onClick={() => this.selectLocation(card.packNumber)}>{locSymbol} {card.name} {status}</li>);
    };
}